import * as PIXI from "pixi.js";


export default class DrawCountNotification extends PIXI.Container
{
    private _text: PIXI.Text = null;


    public constructor()
    {
        super();

        let bg: PIXI.Graphics = new PIXI.Graphics();
        bg.beginFill( 0x323c6a, 0.9 );
        const kHalfWidth: number = 200;
        const kHalfHeight: number = 40;
        bg.drawRoundedRect( -kHalfWidth, -kHalfHeight, kHalfWidth * 2, kHalfHeight * 2, 30 );
        bg.endFill();
        this.addChild( bg );

        this._text = new PIXI.Text( "Current draw: +2", { fontFamily: "asap_regular", fontSize: 40, fill: 0xffffdf } );
        this._text.anchor.set( 0.5 );
        this.addChild( this._text );
    }

    public setDrawCount( count: number ): void
    {
        this._text.text = "Current draw: +" + count.toString();
    } 
}
